import React from 'react';

import Copy from '../../../common/components/Copy';
import DelayedPaper from './DelayedPaper';

const SiteError = () => (
  <DelayedPaper delay={0}>
    <Copy.Header>Error</Copy.Header>
    <Copy.Body>Could not load the app</Copy.Body>
  </DelayedPaper>
);

export default SiteError;
